
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import {  } from "@newview/ui";
import LMap from 'leaflet'
import "leaflet/dist/leaflet.css";
import "leaflet-bing-layer"
@Component({
  name: "nvmap",
  components: {
    
  },
})
export default class NvMapClass extends BaseVue {
  @Prop({ default: "light" }) theme!: any;       //地图主题
  @Prop({ default: {
    type:1,
    zoom:7,
    maxZoom: 24,
    minZoom: 5,
    center:[34.994003757575776,109.31396484375001],
  } }) option!: any;       //地图主题
//#region 接口定义区

//#endregion 接口定义区


//#region 变量定义区
/** 地图渲染容器id */
mapContent = this.NewGuid()
type = 2  //地图类型  1:天地图  2:必应
mapTheme = "light"
/** 地图对象 */
map
layer1
layerIsLoad = false
/** 天地图密钥 */
TDT_KEY = ""
/** bingmap密钥 */
Bing_KEY = ""

//#endregion 变量定义区


//#region 事件定义区
  mounted() {
    $.get("/static/otherConfig.json",(data)=>{
      this.type = data.MapType?data.MapType:2
      this.TDT_KEY = data.TTDMapKey
      this.Bing_KEY = data.BingMapKey
      this.init()
    })
  }

  
  /**
   * 初始化
   */
  private init() {
    this.mapTheme = this.theme
    this.$nextTick(()=>{
      const CVA_C = `tdt/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.TDT_KEY}`
      let layers:any = []
      if(this.type == 1){
        this.layer1 = LMap.tileLayer(this.getLayer(this.option.type), {
          tileSize: 256,
          layers: 'layers1'
        });
        const layer2 = LMap.tileLayer(CVA_C, {
          tileSize: 256,
          layers: 'layers2'
        });
        layers = [this.layer1,layer2]
      }else{
        let imagerySet = ""
        if(this.option.type==1){
          // 不允许使用该地图（国界线有误）
          // imagerySet = "RoadOnDemand"
          imagerySet = "Aerial"
        }else{
          imagerySet = "Aerial"
        }
        let myStyle = {
          "elements": {
              "water": { "fillColor": "#a1e0ff" },
              "waterPoint": { "iconColor": "#a1e0ff" },
              "transportation": { "strokeColor": "#aa6de0" },
              "road": { "fillColor": "#ff0000" },
              "railway": { "strokeColor": "#a495b2" },
              "structure": { "fillColor": "#ffffff" },
              "runway": { "fillColor": "#ff7fed" },
              "area": { "fillColor": "#f39ebd" },
              "political": { "borderStrokeColor": "#fe6850", "borderOutlineColor": "#55ffff" },
              "point": { "iconColor": "#ffffff", "fillColor": "#FF6FA0", "strokeColor": "#DB4680" },
              "transit": { "fillColor": "#AA6DE0" }
          },
          "version": "1.0" 
        };
        this.layer1 = LMap.tileLayer.bing({
          bingMapsKey:this.Bing_KEY,
          imagerySet:imagerySet,
          culture:"zh-Hans",
          style:myStyle
        })
        layers = [this.layer1]
      }
      this.map = LMap.map(this.mapContent,{
        // crs:LMap.CRS.EPSG4326,
        maxZoom: this.option.maxZoom,
        minZoom: this.option.minZoom,
        center:this.option.center,
        zoom: this.option.zoom,
        zoomControl: false,
        renderer: LMap.canvas({ tolerance: 16 }),
        layers: layers,
        attributionControl: false // 移除右下角leaflet标识
      })
      this.layer1.on("load",()=>{
        if(!this.layerIsLoad){
          this.$emit('onload')
        }        
        this.layerIsLoad = true
      })
      this.map.on("click",(param)=>{
        this.$emit('click',param)
      })

      this.map.on("movestart",()=>{
        console.log("movestart")
      })
      
      this.map.on("moveend",()=>{
        console.log("moveend")
      })
      this.map.on("load",()=>{
        console.log("load")
      })
    })
  }


  

  /**
   * 获取地图对象
   * @returns map对象
   */
   getMap(){
    return this.map
  }

  /**
   * 设置地图中心点
   * @param position 
   */
  setCenter(position){
    this.map.setView(position)
  }
  /**
   * 设置地图缩放级别
   * @param zoom 
   */
  setZoom(zoom:Number){
    this.map.setZoom(zoom)
  }

  /**
   * 将地图的视图设置在给定矢量覆盖物范围内
   * @param overlay 
   */
  flyToOverlay(overlay){
    this.map.flyToBounds(overlay.getBounds());
  }

  /**
   * 重置地图大小
   */
  reSize(){
    this.map.invalidateSize()
  }
  
  /**
   * 设置地图类型
   * @param type 1普通地图  2影像地图
   */
  setMapType(type){
    let imagerySet = ""
    if(type==1){
      // 不允许使用该地图（国界线有误）
      // imagerySet = "RoadOnDemand"
      imagerySet = "Aerial"
      this.mapTheme = this.theme
    }else{
      imagerySet = "Aerial"
      this.mapTheme = 'light'
    }
    if(this.type==1){
      this.layer1.setUrl(this.getLayer(type))
    }else{      
      this.layer1.remove();
      this.layer1 = LMap.tileLayer.bing({
        bingMapsKey:this.Bing_KEY,
        imagerySet:imagerySet,
        culture:"zh-Hans",
      })
      this.layer1.addTo(this.map)
    }
  }

  /**
   * 根据类别获取地图图层
   * @param type 1普通地图  2影像地图
   * @returns 
   */
  getLayer(type){
    let obj = {
      1:`tdt/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.TDT_KEY}`,
      2:`tdt/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.TDT_KEY}`
    }
    return obj[type]
  }

  
  /**
   * 绘制标记点
   * @param position 位置
   * @param option 其他配置项 
   */
   addMarker(position,option:any={}){
    if(this.type == 2){
      position = this.type2Point(position)
    }
    let marker = LMap.marker(position, option).addTo(this.map);
    option.offset && this.offset(marker,option.offset)
    if(option.popupContent){
      marker.bindPopup(option.popupContent)
    }
    return marker
  }

  /**
   * 标记偏移
   * @param marker 标记对象
   * @param offset 偏移量[0,0] 第一项为top偏移，第二项为left偏移
   */
  offset(marker,offset){
    if(offset.length == 0 || !marker) return
    if(offset[0] && offset[0] !== 0){
      marker!._icon.style.marginTop = offset[0] + 'px'
    }
    if(offset[1] && offset[1] !== 0){
      marker!._icon.style.marginLeft = offset[1] + 'px'
    }
  }

  /**
   * 绘制文字标记
   * @param position 位置
   * @param content 文本内容 
   * @param style css样式
   */
  addLabel(position,content,style:String="",options:any = {}){
    let markerIcon = LMap.divIcon({
      html: `<span style="${style}">${content}</span>`,//marker标注
      className: 'nv-map-label'
    });
    if(this.type == 2){
      position = this.type2Point(position)
    }
    let labelMark = LMap.marker(position, { icon: markerIcon,...options }).addTo(this.map);

    options.offset && this.offset(labelMark,options.offset)
     return labelMark
  }
  /**
   * 绘制线
   * @param option 其他配置项 
   */
  addPolyline(points,option:any={}){
    if(this.type == 2 && points && points[0]){
      points = points.map(e=>{
        return this.type2Point(e)
      })
    }
    let polyline = LMap.polyline(points, option).addTo(this.map);
    if(option.popupContent){
      polyline.bindPopup(option.popupContent)
    }
    return polyline
  }
  
  /**
   * 绘制多边形
   * @param option 其他配置项 
   */
  addPolygon(points,option:any={}){
    if(this.type == 2 && points && points[0]){
      points = points.map(e=>{
        return this.type2Point(e)
      })
    }
    let polygon = LMap.polygon(points, option).addTo(this.map);
    if(option.popupContent){
      polygon.bindPopup(option.popupContent)
    }
    return polygon
  }
  /**
   * 绘制圆形
   * @param center 中心点坐标 
   * @param radius 圆半径 
   * @param option 其他配置项 
   */
  addCircle(center,radius:Number=100,option={}){
    if(this.type == 2){
      center = this.type2Point(center)
    }
    let circle = LMap.circle(center,Object.assign({radius:radius},option)).addTo(this.map);
    return circle
  }

  /**
   * 加载geoJSON图层
   * @param data geoJson数据
   * @param option 其他配置项（样式）
   */
  addGeoJSON(data,option){
    let geoObj = LMap.geoJSON(data, {
      style: function (feature) {
        return option;
      }
    }).addTo(this.map);
    return geoObj
  }

//#endregion 事件定义区


//#region 方法定义区
  type2Point(point){
    if(this.isArray(point)){
      return this.LngLatConvert.WGS84_TO_GCJ02(point[1],point[0],true)
    }else{
      return this.LngLatConvert.WGS84_TO_GCJ02(point.longitude,point.latitude,true)
    }
  }

  public isArray(arr) {
        return Array.isArray(arr)
    }

//#endregion 方法定义区
}
